import StatementCommunication from '~/pages/communication/statement/libs/components/StatementCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const StatementCommunicationPage = (props: TPageProps) => (
  <StatementCommunication {...props} />
)

export default StatementCommunicationPage
